export const UNASSIGNED_KANBAN_COLUMN_VALUE = '__unassigned__';
